import { useState, useRef } from "react";

export function useAppData() {
  const [token, setToken] = useState(null);
  const [retake, setRetake] = useState(null);
  const [config, setConfig] = useState({});
  const [currentBlock, setCurrentBlock] = useState({});
  const [screen, setScreen] = useState("loading");
  const [condition, setCondition] = useState({});
  const [subCondition, setSubCondition] = useState({});
  const [subConditionSub, setSubConditionSub] = useState({});
  const [mandatory, setMandatory] = useState({});
  const [subMandatory, setSubMandatory] = useState({});
  const [subMandatorySub, setSubMandatorySub] = useState({});
  const [showOptions, setShowOptions] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [showDescription, setShowDescription] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [uploaded, setUploaded] = useState(false);
  const [isLandscape, setLandscape] = useState(false);
  const [count, setCount] = useState(0);
  const [count1, setCount1] = useState(0);
  const [imgPosition, setImgPosition] = useState(null);
  const [currentDamage, setCurrentDamage] = useState(0);
  const [fImg, setFImg] = useState(null);
  const [sImg, setSImg] = useState(null);
  const [page, setPage] = useState("inst");
  const [completed, setCompleted] = useState(false);
  const [subCompleted, setSubCompleted] = useState(false);
  const [mandatoryCompleted, setMandatoryCompleted] = useState(false);
  const [subMandatoryCompleted, setSubMandatoryCompleted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [inspectionId, setInspectionId] = useState(null);
  const [location, setLocation] = useState({ latitude: 0, longitude: 0 });
  const [showZeroCamera, setShowZeroCamera] = useState(false);
  const [showQRCamera, setShowQRCamera] = useState(true);
  const [previewZeroImg, setPreviewZeroImg] = useState(null);
  const [previewQRImg, setPreviewQRImg] = useState(null);
  const [scrollX, setscrollX] = useState(0);
  const [scrolEnd, setscrolEnd] = useState(false);
  const [pings, setPings] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [stopPing, setStopPing] = useState(true);
  const [clientId, setClientId] = useState(null);
  const [clientUniqueIdentity, setClientUniqueIdentity] = useState("");
  const [currentPage, setCurrentPage] = useState("");
  const [stepCovered, setStepCovered] = useState([]);
  const [autoRotate, setAutoRotate] = useState(false);
  const [phone, setPhone] = useState(null);
  const [damageModuleCompleted, setDamageModuleCompleted] = useState(false);
  const [caseId, setCaseId] = useState("");
  const [hiibCustomValue, setHiibCustomValue] = useState(false);
  const [VINDeteted, setVINDeteted] = useState(false);
  const [feedBackStatus, setFeedBackStatus] = useState("");
  const [totalImageForAnalysis, setTotalImageForAnalysis] = useState([]);
  const [callOnceFeedBack, setCallOnceFeedBack] = useState(true);
  const [totalImageFeedbackMssg, setTotalImageFeedbackMssg] = useState({});
  const [feedBackBtndisabled, setFeedBackBtndisabled] = useState(false);
  const [feedBackMssg, setFeedBackMssg] = useState("");
  const [feedbackReceived, setFeedbackReceived] = useState([]);
  const [showFeedBackWarning, setShowFeedBackWarning] = useState(false);
  const [totalPhotoCount, setTotalPhotoCount] = useState(0);
  const [restrictUserIfallNotGreen, setRestrictUserIfallNotGreen] =
    useState(true);
  const [imageFeedbackPopupRef, setImageFeedbackPopupRef] = useState(false);
  const [storedImage, setStoredImage] = useState([]);
  const [currentImage, setCurrentImage] = useState({});
  const [tempStream, setTempStream] = useState(null);
  const [isIOS, setIsIOS] = useState(null);
  const [isSwitchToLandscape, setIsSwitchToLandscape] = useState(false);
  const [alignStencil, setalignStencil] = useState([]);
  const [capturedStencil, setcapturedStencil] = useState([]);
  const [skipStencil, setSkipStencil] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [gyroPermission, setGyroPermission] = useState(null);
  const [cameraPermission, setCameraPermission] = useState(null);
  const [storeCompleteTag, setStoreCompleteTag] = useState([]);
  const [storeCompleteImage, setStoreCompleteImage] = useState([]);
  const [nameTag, setNameTag] = useState({});
  const [totalImage, setTotalImage] = useState([]);
  const [inputMetaData, setInputMetaData] = useState({});

  const [docs, setDocs] = useState({
    rc: [],
    claimForm: [],
    dl: [],
    estimateCopy: [],
    claimReason: ""
  });
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({ title: "", message: "" });
  const [previewItem, setPreviewItem] = useState(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [activeDocId, setActiveDocId] = useState(null);
  const [stream, setStream] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);

  const [fallbackCondition, setFallbackCondition] = useState({});
  const [fallbackSubCondition, setFallbackSubCondition] = useState({});
  const [fallbackMandatory, setFallbackMandatory] = useState({});
  const [fallbackSubMandatory, setFallbackSubMandatory] = useState({});
  const [fallbackBlockId, setFallbackBlockId] = useState("");

  return {
    fallbackCondition,
    setFallbackCondition,
    fallbackSubCondition,
    setFallbackSubCondition,
    fallbackMandatory,
    setFallbackMandatory,
    fallbackSubMandatory,
    setFallbackSubMandatory,
    fallbackBlockId,
    setFallbackBlockId,
    docs,
    setDocs,
    showErrorPopup,
    setShowErrorPopup,
    popupContent,
    setPopupContent,
    previewItem,
    setPreviewItem,
    isCameraOpen,
    setIsCameraOpen,
    activeDocId,
    setActiveDocId,
    stream,
    setStream,
    isFormValid,
    setIsFormValid,
    inputMetaData,
    setInputMetaData,
    totalImage,
    setTotalImage,
    nameTag,
    setNameTag,
    storeCompleteTag,
    storeCompleteImage,
    setStoreCompleteTag,
    setStoreCompleteImage,
    gyroPermission,
    setGyroPermission,
    cameraPermission,
    setCameraPermission,
    disabled,
    setDisabled,
    skipStencil,
    setSkipStencil,
    alignStencil,
    setalignStencil,
    capturedStencil,
    setcapturedStencil,
    storedImage,
    setStoredImage,
    currentImage,
    setCurrentImage,
    restrictUserIfallNotGreen,
    setRestrictUserIfallNotGreen,
    totalImageFeedbackMssg,
    setTotalImageFeedbackMssg,
    callOnceFeedBack,
    setCallOnceFeedBack,
    totalImageForAnalysis,
    setTotalImageForAnalysis,
    caseId,
    setCaseId,
    damageModuleCompleted,
    setDamageModuleCompleted,
    stepCovered,
    setStepCovered,
    token,
    setToken,
    config,
    setConfig,
    currentBlock,
    setCurrentBlock,
    screen,
    setScreen,
    condition,
    setCondition,
    showOptions,
    setShowOptions,
    clientId,
    setClientId,
    userEmail,
    setUserEmail,
    uploaded,
    setUploaded,
    isLandscape,
    setLandscape,
    count,
    setCount,
    imgPosition,
    setImgPosition,
    currentDamage,
    setCurrentDamage,
    fImg,
    setFImg,
    sImg,
    setSImg,
    page,
    setPage,
    showDescription,
    setShowDescription,
    mandatory,
    setMandatory,
    autoRotate,
    setAutoRotate,
    completed,
    setCompleted,
    mandatoryCompleted,
    setMandatoryCompleted,
    subMandatory,
    subMandatorySub,
    setSubMandatory,
    setSubMandatorySub,
    subCompleted,
    setSubCompleted,
    phone,
    setPhone,
    subMandatoryCompleted,
    setSubMandatoryCompleted,
    subCondition,
    subConditionSub,
    setSubCondition,
    setSubConditionSub,
    showPreview,
    setShowPreview,
    count1,
    setCount1,
    clientUniqueIdentity,
    setClientUniqueIdentity,
    errorMessage,
    setErrorMessage,
    location,
    setLocation,
    inspectionId,
    setInspectionId,
    retake,
    setRetake,
    showZeroCamera,
    setShowZeroCamera,
    currentPage,
    setCurrentPage,
    previewZeroImg,
    setPreviewZeroImg,
    showQRCamera,
    setShowQRCamera,
    previewQRImg,
    setPreviewQRImg,
    scrollX,
    setscrollX,
    scrolEnd,
    setscrolEnd,
    pings,
    setPings,
    showAlert,
    setShowAlert,
    stopPing,
    setStopPing,
    hiibCustomValue,
    setHiibCustomValue,
    VINDeteted,
    setVINDeteted,
    feedBackStatus,
    setFeedBackStatus,
    feedBackBtndisabled,
    setFeedBackBtndisabled,
    feedBackMssg,
    setFeedBackMssg,
    feedbackReceived,
    setFeedbackReceived,
    showFeedBackWarning,
    setShowFeedBackWarning,
    totalPhotoCount,
    setTotalPhotoCount,
    imageFeedbackPopupRef,
    setImageFeedbackPopupRef,
    tempStream,
    setTempStream,
    isIOS,
    setIsIOS,
    isSwitchToLandscape,
    setIsSwitchToLandscape,
  };
}
